import React from "react";
import {translate} from "react-i18next";

const Csts = ({t}) => {
    return (
        <div className="history-tab">
            <h4 className="header">{t('about.history.csts.header')}</h4>
            <p>{t('about.history.csts.line1')}</p>
            <p>{t('about.history.csts.line2')}</p>
            <p>{t('about.history.csts.line3')}</p>
        </div>
    )
}

export default translate('common')(Csts);